export default function StudyCost({ data }) {
  const currencyCode = data.studyCost.currency_code;
  return (
    <div className="bg-white border rounded-2xl p-6">
      <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
        <img src="/courseDetails/CO.png" alt="SER" className="h-5 w-5" />{" "}
        Admission Fees
      </h3>

      <div className="grid md:grid-cols-2 gap-6 text-sm">
        <div>
          <p className="text-gray-500">Annual Tuition Fees</p>
          <p className="font-semibold">
            {currencyCode} {data.studyCost.annual_tution_fees}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Total Tuition Fees</p>
          <p className="font-semibold">
            {data.studyCost.currency_code} {data.studyCost.total_tution_fees}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Visa Fees</p>
          <p className="font-semibold">
            {currencyCode} {data.studyCost.visa_fees}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Offer TAT</p>
          <p className="font-semibold">{data.studyCost.offer_tat}</p>
        </div>
      </div>
    </div>
  );
}
